// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gridButton {
  background-color: white;
  position: absolute;
  top: 0;
  left: 16%;
  transform: translateX(-50%);
  height: 36px;
  width: 100px;
  border-radius: 36px;
  line-height: 36px;
  text-align: center;
  color: black;
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  flex-direction: row;
}
.gridButton span {
  flex: 3;
  text-align: left;
  margin-right: 8px;
}
.gridButton i {
  flex: 1;
  text-align: right;
  line-height: 40px;
  margin-right: 4px;
}
.gridButton.active {
  background-color: #0076FF;
  color: white;
}
.gridModal {
  width: 0px;
  height: 0px;
  overflow: unset !important;
  top: unset !important;
  left: calc(50% - 500px) !important;
  bottom: 260px !important;
}
.gridModal .ant-modal {
  top: -175px !important;
  color: black;
}
.gridModal .ant-modal-content {
  width: 989px;
}
.gridModal .ant-modal-header {
  border: none;
  padding: 0;
}
.gridModal .ant-modal-body {
  padding: 0 21px 7px 21px;
}
.gridModal .ant-modal-body .tableWrapper {
  height: 192px;
  border: 1px solid lightgray;
  box-sizing: content-box;
  border-radius: 8px;
  overflow: hidden;
}
.gridModal .ant-modal-body .tableWrapper .row {
  height: 24px;
}
.gridModal .ant-modal-body .tableWrapper .row:not(:nth-of-type(8)) {
  border-bottom: 1px solid lightgray;
}
.gridModal .ant-modal-body .tableWrapper .row.IPR div,
.gridModal .ant-modal-body .tableWrapper .row.Gap div {
  position: relative;
}
.gridModal .ant-modal-body .tableWrapper .row .placeholder1,
.gridModal .ant-modal-body .tableWrapper .row .placeholder2 {
  width: 23px;
  height: 24px;
  border: none;
  background-color: #E6E6E6;
}
.gridModal .ant-modal-body .tableWrapper .row .placeholder2 {
  left: 2px;
}
.gridModal .ant-modal-body .tableWrapper .row.IPR .data,
.gridModal .ant-modal-body .tableWrapper .row.Gap .data {
  border-width: 1px;
}
.gridModal .ant-modal-body .tableWrapper .row.IPR .data:nth-of-type(10) i svg,
.gridModal .ant-modal-body .tableWrapper .row.Gap .data:nth-of-type(10) i svg {
  left: calc(50% + 1px) !important;
}
.gridModal .ant-modal-body .tableWrapper .row div {
  float: left;
  width: 46px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
}
.gridModal .ant-modal-body .tableWrapper .row div.firstCell {
  padding-left: 12px;
}
.gridModal .ant-modal-body .tableWrapper .row div:not(.firstCell) {
  border-left: 1px solid lightgray;
  text-align: center;
}
.gridModal .ant-modal-body .tableWrapper .row div:nth-of-type(10) {
  border-left: 3px solid lightgray;
}
.gridModal .ant-modal-body .tableWrapper .row div.firstCell {
  width: 208px;
}
.gridModal .ant-modal-body .tableWrapper .row .head {
  text-align: center !important;
  padding-right: 0px !important;
}
.gridModal .ant-modal-body .tableWrapper .row .head span {
  font-weight: bold !important;
}
.gridModal .ant-modal-body .tableWrapper .row .head:nth-of-type(1) {
  text-align: left !important;
}
.gridModal .ant-modal-body .tableWrapper .row .empty {
  text-align: center !important;
  padding-right: 0px !important;
}
.gridModal .buttonStyle {
  width: 115px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  display: inline-block;
  border: 1px solid #DCDDE0;
  border-radius: 8px;
  cursor: pointer;
  color: #888888;
  transition: 0.3s;
}
.gridModal .activeBtn {
  background-color: #0076FF;
  color: white;
  border: 1px solid #0076FF;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/Grid/index.less"],"names":[],"mappings":"AAEA;EACE,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AADF;AAdA;EAkBI,OAAA;EACA,gBAAA;EACA,iBAAA;AADJ;AAnBA;EAwBI,OAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAFJ;AAME;EACE,yBAAA;EACA,YAAA;AAJJ;AAQA;EACE,UAAA;EACA,WAAA;EACA,0BAAA;EACA,qBAAA;EACA,kCAAA;EACA,wBAAA;AANF;AAAA;EAUI,sBAAA;EAEA,YAAA;AARJ;AAJA;EAqBI,YAAA;AAdJ;AAPA;EAyBI,YAAA;EACA,UAAA;AAfJ;AAXA;EA8BI,wBAAA;AAhBJ;AAdA;EAiCM,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAhBN;AArBA;EAwCQ,YAAA;AAhBR;AAkBQ;EACE,kCAAA;AAhBV;AAmBQ;;EAGI,kBAAA;AAlBZ;AA/BA;;EAwDU,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AArBV;AAtCA;EA+DU,SAAA;AAtBV;AAyBQ;;EAEE,iBAAA;AAvBV;AA6BY;;EAGM,gCAAA;AA5BlB;AAjDA;EAqFU,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAjCV;AAmCU;EACE,kBAAA;AAjCZ;AAoCU;EACE,gCAAA;EACA,kBAAA;AAlCZ;AAqCU;EACE,gCAAA;AAnCZ;AAsCU;EACE,YAAA;AApCZ;AArEA;EAgHU,6BAAA;EACA,6BAAA;AAxCV;AAzEA;EAoHY,4BAAA;AAxCZ;AA2CU;EACE,2BAAA;AAzCZ;AA/EA;EA6HU,6BAAA;EACA,6BAAA;AA3CV;AAnFA;EAqII,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA/CJ;AA/FA;EAkJI,yBAAA;EACA,YAAA;EACA,yBAAA;AAhDJ","sourcesContent":["@import \"src/style/common.less\";\n\n.gridButton {\n  background-color: white;\n  position: absolute;\n  top: 0;\n  left: 16%;\n  transform: translateX(-50%);\n  height: 36px;\n  width: 100px;\n  border-radius: 36px;\n  line-height: 36px;\n  text-align: center;\n  color: black;\n  cursor: pointer;\n  transition: .3s;\n  display: flex;\n  flex-direction: row;\n\n  span {\n    flex: 3;\n    text-align: left;\n    margin-right: 8px;\n  }\n\n  i {\n    flex: 1;\n    text-align: right;\n    line-height: 40px;\n    margin-right: 4px;\n  }\n\n\n  &.active {\n    background-color: @button-blue-color;\n    color: white;\n  }\n}\n\n.gridModal {\n  width: 0px;\n  height: 0px;\n  overflow: unset !important;\n  top: unset !important;\n  left: calc(50% - 500px) !important;\n  bottom: 260px !important;\n  //transform: translateX(-50%);\n\n  .ant-modal {\n    top: -175px !important;\n    //bottom: 200px;\n    color: black;\n  }\n\n  .ant-modal-close-x {\n    //display: none;\n  }\n\n  .ant-modal-content {\n    // height: 260px;\n    width: 989px;\n  }\n\n  .ant-modal-header {\n    border: none;\n    padding: 0;\n  }\n\n  .ant-modal-body {\n    padding: 0 21px 7px 21px;\n\n    .tableWrapper {\n      height: 192px;\n      border: 1px solid lightgray;\n      box-sizing: content-box;\n      border-radius: 8px;\n      overflow: hidden;\n\n      .row {\n        height: 24px;\n\n        &:not(:nth-of-type(8)) {\n          border-bottom: 1px solid lightgray;\n        }\n\n        &.IPR,\n        &.Gap {\n          div {\n            position: relative;\n          }\n        }\n\n\n        .placeholder1,\n        .placeholder2 {\n          width: 23px;\n          height: 24px;\n          border: none;\n          background-color: #E6E6E6;\n        }\n\n        .placeholder2 {\n          left: 2px;\n        }\n\n        &.IPR .data,\n        &.Gap .data {\n          border-width: 1px;\n        }\n\n        &.IPR,\n        &.Gap {\n          .data {\n            &:nth-of-type(10) {\n              i {\n                svg {\n                  left: calc(50% + 1px) !important;\n                }\n              }\n            }\n          }\n        }\n\n        div {\n          float: left;\n          width: 46px;\n          height: 24px;\n          line-height: 24px;\n          font-size: 12px;\n\n          &.firstCell {\n            padding-left: 12px;\n          }\n\n          &:not(.firstCell) {\n            border-left: 1px solid lightgray;\n            text-align: center;\n          }\n\n          &:nth-of-type(10) {\n            border-left: 3px solid lightgray;\n          }\n\n          &.firstCell {\n            width: 208px;\n          }\n        }\n\n\n\n        .head {\n          text-align: center !important;\n          padding-right: 0px !important;\n\n          span {\n            font-weight: bold !important;\n          }\n\n          &:nth-of-type(1) {\n            text-align: left !important;\n          }\n        }\n\n        .empty {\n          text-align: center !important;\n          padding-right: 0px !important;\n        }\n      }\n    }\n  }\n\n  .buttonStyle {\n    width: 115px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border: 1px solid #DCDDE0;\n    border-radius: 8px;\n    cursor: pointer;\n    color: #888888;\n    transition: .3s;\n  }\n\n  .activeBtn {\n    background-color: @button-blue-color;\n    color: white;\n    border: 1px solid @button-blue-color;\n  }\n}\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
